import type { FleetTypeCount } from '@/api/hooks'
import { ShipIcon } from '@/components/game/GameIcons'

/**
 * Composition d'une flotte engagée, par type de navire — icône + compte + libellé.
 * Partagé par le détail carte (`MissionDetail`) et le dépliant de la carte de
 * mission du tableau de bord (`MissionCard`) pour ne pas dupliquer le rendu.
 */
export function FleetComposition({ fleet }: { fleet: FleetTypeCount[] }) {
  return (
    <ul className="space-y-1">
      {fleet.map((f) => (
        <li key={f.shipType} data-role="fleet-line" className="flex items-center gap-2 text-sm text-ocean-100">
          <ShipIcon type={f.shipType} className="w-5 h-5 text-sand-300" />
          <span className="tabular-nums text-sand-200 font-semibold">{f.count}</span>
          <span className="text-ocean-300">{f.shipTypeLabel}</span>
        </li>
      ))}
    </ul>
  )
}
